import { COLORS } from "@components/Charts/commons";
import {AMChartDountData} from "./Game.type";

type Category = 'won' | 'lost' | 'specified';

type Source = Partial<Record<Category, { val: number; amt: number }>>;

export const toArray = (
  data: Source,
  intl: any,
  opts?: {
    order?: Category[]; // ordine esplicito delle categorie
    measure?: 'val' | 'amt'; // quale misura usare, di default 'val'
  }
): AMChartDountData[] => {
  // Se opts.order non c’è, Object.keys(data) restituisce string[], quindi castiamo a Category[]
  const keys = (opts?.order ?? Object.keys(data)) as Category[];

  // Palette fortemente tipizzata
  const palette: Record<Category, { fill: string | number; stroke: string }> = {
    won: { fill: COLORS['analytics_survey_won'], stroke: COLORS['analytics_survey_won'] },
    lost: { fill: COLORS['analytics_survey_lost'], stroke: COLORS['analytics_survey_lost'] },
    specified: { fill: COLORS['analytics_survey_specified'], stroke: COLORS['analytics_survey_specified'] },
  };

  return keys
    .filter((k) => k in data) // ignora chiavi sconosciute in un eventuale ordine custom
    .map((key, idx) => {
      // data[key] può essere undefined perché Source è Partial, quindi facciamo una guard
      const src = data[key];
      if (!src) return undefined; // opzionale: puoi anche filtrare prima

      const colors = palette[key];

      const item: AMChartDountData = {
        category: intl.formatMessage({id:'analytics_survey_'+key}),
        value: src[opts?.measure ?? 'val'],
        order: idx,
        settings: {
          fill: colors.fill,
          stroke: colors.stroke,
        },
      };

      return item;
    })
    .filter((x): x is AMChartDountData => !!x); // togli gli undefined se usi la guard
};

